import {
  Component,
  ElementRef,
  ViewChild,
  Input,
  AfterViewInit,
  OnDestroy,
  HostListener,
} from '@angular/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { Carousel } from 'src/app/interfaces/strapi';
import { NgIf, NgFor } from '@angular/common';
import { CmsLinkComponent } from '../cms-link/cms-link.component';
import HeaderComponent from '../header/header.component';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    imports: [
        NgIf,
        NgFor,
        CmsLinkComponent,
        HeaderComponent,
    ],
})
export class CarouselComponent implements AfterViewInit, OnDestroy {
  @Input() carousel: Carousel | null | undefined;

  @Input() public cardStyle: 'primary' | 'tertiary' | undefined;

  @ViewChild('sliderRef') private readonly sliderRef!: ElementRef<HTMLElement>;

  @HostListener('window:resize')
  onScreenChange() {
    this.isMobile = window.innerWidth < 992;
  }

  public isMobile: boolean = window.innerWidth < 992;

  public currentSlideIndex = 0;

  public slider: KeenSliderInstance | null = null;

  ngAfterViewInit() {
    if (this.sliderRef) {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
          spacing: 8,
        },

        breakpoints: {
          '(min-width: 992px)': {
            loop: this.showArrows,
            slides: {
              perView: 4,
              spacing: 15,
            },
          },
        },
        slideChanged: (s) => {
          this.currentSlideIndex = s.track.details.abs;
        },
      });
    }
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  public get showArrows(): boolean {
    return !!(this.carousel?.slides && this.carousel.slides.length > 4);
  }

  public doPrev(): void {
    this.slider?.prev();
  }

  public doNext(): void {
    this.slider?.next();
  }
}
